module.exports = __webpack_public_path__ + "img/Hippie.5c8623f8.jpg";